"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BorderBase = void 0;
var color_1 = require("../color/color");
var enums_1 = require("./enums");
var BorderBase = (function () {
    function BorderBase(style, width, color) {
        this.style = style;
        this.width = width;
        this.color = color;
    }
    BorderBase.getEmpty = function () {
        return BorderBase.empty.clone();
    };
    BorderBase.prototype.clone = function () {
        return new BorderBase(this.style, this.width, this.color);
    };
    BorderBase.prototype.equals = function (obj) {
        return obj &&
            this.style == obj.style &&
            this.width == obj.width &&
            this.color == obj.color;
    };
    BorderBase.empty = new BorderBase(enums_1.BorderLineStyle.None, 0, color_1.ColorHelper.AUTOMATIC_COLOR);
    return BorderBase;
}());
exports.BorderBase = BorderBase;
